<template>
  <div>
    <div class="java110_step">
      <el-steps :active="addAuditUserStepInfo.index" finish-status="success" align-center>
        <el-step title="选择分公司"></el-step>
        <el-step title="选择部门"></el-step>
        <el-step title="选择员工"></el-step>
        <el-step title="扩展信息"></el-step>
      </el-steps>
    </div>

    <!-- 选择应用信息 -->
    <div v-if="addAuditUserStepInfo.index === 0 || addAuditUserStepInfo.index === 1">
      <view-org-info 
        ref="viewOrgInfo"
        :call-back-listener="'addAuditUserStep'"
        :call-back-function="'notify'"
      ></view-org-info>
    </div>
    <div v-if="addAuditUserStepInfo.index === 2">
      <view-staff-info
        ref="viewStaffInfo"
        :call-back-listener="'addAuditUserStep'"
        :call-back-function="'notify'"
      ></view-staff-info>
    </div>
    <div v-if="addAuditUserStepInfo.index === 3">
      <add-audit-user-other-view
        ref="addAuditUserOtherView"
        :call-back-listener="'addAuditUserStep'"
        :call-back-function="'notify'"
      ></add-audit-user-other-view>
    </div>

    <el-row>
      <el-col :span="22" :offset="2">
        <div class="step-buttons">
          <el-button type="info" @click="_prevStep()">上一步</el-button>
          <el-button 
            v-if="addAuditUserStepInfo.index !== 3" 
            type="primary" 
            @click="_nextStep()"
          >下一步</el-button>
          <el-button 
            v-if="addAuditUserStepInfo.index === 3" 
            type="primary" 
            @click="_finishStep()"
          >完成</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ViewOrgInfo from '@/components/frame/viewOrgInfo/viewOrgInfo.vue'
import ViewStaffInfo from '@/components/frame/viewStaffInfo/viewStaffInfo.vue'
import AddAuditUserOtherView from '@/components/common/addAuditUserOtherView/addAuditUserOtherView.vue'
import { bindingAuditUser } from '@/api/common/addAuditUserStepApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddAuditUserStep',
  components: {
    ViewOrgInfo,
    ViewStaffInfo,
    AddAuditUserOtherView
  },
  data() {
    return {
      addAuditUserStepInfo: {
        index: 0,
        infos: [],
        branchOrgInfo: {
          orgId: '',
          componentName: '分公司信息',
          buttonName: '选择分公司',
          orgName: '',
          orgLevel: '2',
          parentOrgId: '',
          description: ''
        },
        departmemtOrgInfo: {
          orgId: '',
          componentName: '部门信息',
          buttonName: '选择部门',
          orgName: '',
          orgLevel: '3',
          parentOrgId: '',
          description: ''
        },
        viewStaffInfo: {
          index: 0,
          flowComponent: 'viewStaffInfo',
          userId: '',
          name: '',
          email: '',
          tel: '',
          sex: '',
          orgId: ''
        },
        auditUserInfo: {
          userId: '',
          userName: '',
          auditLink: '',
          objCode: ''
        }
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
  },
  mounted() {
    this._initStep()
  },
  methods: {
    _initStep() {
      this.addAuditUserStepInfo.index = 0
      this._notifyViewOrgInfoComponentData()
    },
    _prevStep() {
      if (this.addAuditUserStepInfo.index > 0) {
        this.addAuditUserStepInfo.index--
        this._notifyViewOrgInfoComponentData()
      }
    },
    _nextStep() {
      const currentData = this.addAuditUserStepInfo.infos[this.addAuditUserStepInfo.index]
      if (!currentData) {
        this.$message.warning('请选择或填写必选信息')
        return
      }
      this.addAuditUserStepInfo.index++
      this._notifyViewOrgInfoComponentData()
    },
    async _finishStep() {
      const currentData = this.addAuditUserStepInfo.infos[this.addAuditUserStepInfo.index]
      if (!currentData) {
        this.$message.warning('请选择或填写必选信息')
        return
      }

      try {
        const res = await bindingAuditUser(this.addAuditUserStepInfo.auditUserInfo)
        this.$message.success('处理成功')
        this.$router.push({
          path: '/pages/common/auditUserManage',
          query: res
        })
      } catch (error) {
        this.$message.error(error.message || '处理失败')
      }
    },
    _notifyViewOrgInfoComponentData() {
      if (this.addAuditUserStepInfo.index === 0) {
        this.$refs.viewOrgInfo.initInfo(this.addAuditUserStepInfo.branchOrgInfo)
      } else if (this.addAuditUserStepInfo.index === 1) {
        this.addAuditUserStepInfo.departmemtOrgInfo.parentOrgId = 
          this.addAuditUserStepInfo.branchOrgInfo.orgId
        this.$refs.viewOrgInfo.initInfo(this.addAuditUserStepInfo.departmemtOrgInfo)
      } else if (this.addAuditUserStepInfo.index === 2) {
        this.$refs.viewStaffInfo.initInfo(this.addAuditUserStepInfo.viewStaffInfo)
      }
    }
  }
}
</script>

<style scoped>
.java110_step {
  margin-bottom: 20px;
}
.step-buttons {
  margin-top: 20px;
  text-align: right;
}
</style>